import React, { Component } from 'react';
import { Button, Spin, Table, Col, Row, Modal, message, Icon } from 'antd';
import moment from 'moment';
import _AdminService from 'modules/AdminService';
import DropdownList from 'components/controls/DropdownList';
import PageHeader from 'components/enterprise/PageHeader';
import EmptyState from 'components/enterprise/EmptyState';
import _notification from 'modules/notification';
import { ROOT_PATH } from '../../constants/constants';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';


class ExportCenterWiseAttendanceData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      centerList: [],
      Data: [], // Ensure this is an array to pass into the Table component
      selectedCenter: null,
      loading: false,
      totalCount: 0,
      showDeleteConfirm: false,
    };
  }

  componentDidMount() {
    this.fetchCenters();
  }

  // Converts an array into objects with Id and Name keys for dropdown options.
  transformArray = (responseArray) => {
    return responseArray.map((item) => ({
      Id: item,
      Name: item,
    }));
  };

  // Fetch centers when the page loads
  fetchCenters = async () => {
    this.setState({ loading: true, centerList: [], Data: [], selectedCenter: null });
    try {
      const response = await _AdminService.GetAllCenterBatchList();   // Assuming API returns data in response.data
      this.setState({ centerList: this.transformArray(response.data), loading: false });
    } catch (error) {
      this.setState({ loading: false });
      _notification.showMessage('error', 'Unable to load centers. Please try again.');
    }
  };

  handleCenterChange = async (event) => {
    const selectedCenter = event.target.value;

    // If the selected value is "Select Center" (placeholder), clear data and stop fetching
    if (selectedCenter === "Select Center" || selectedCenter === "") {
      this.setState({ selectedCenter, Data: [], totalCount: 0, loading: false });
      return;
    }

    this.setState({ selectedCenter, loading: true });
    try {
      // Fetch batches based on selected center
      const response = await _AdminService.GetAllCenterBatchDataByCenter(event.target.value);

      // Check if the response contains data in the expected format
      if (response.data) {
        this.setState({ Data: response.data, totalCount: response.data.length, loading: false });
      }

    } catch (error) {
      this.setState({ loading: false });
      _notification.showMessage('error', 'Unable to load attendance data for the selected center. Please try again.');
    }
  };

  deleteCenterBatchData = async () => {
    this.setState({ loading: true });
    try {
      const response = await _AdminService.DeleteCenterBatchData();
      if (response.data.IsSuccess) {
        this.setState({
          centerList: [],
          Data: [],
          selectedCenter: null,
          loading: false,
        });

      } else {
        this.setState({ loading: false });

      }
    } catch (error) {
      this.setState({ loading: false });
      message.error("Failed to delete Center wise attendance data.");
      console.error('Error deleting Center wise attendance data:', error);
    }
  };

  handleDeleteConfirmation = () => {
    this.setState({ showDeleteConfirm: true });
  };

  handleDownload = async () => {
    try {
      this.setState({ loading: true });

      const response = await _AdminService.ExportCenterWiseAttendanceData(this.state.selectedCenter);

      if (response.data && response.status === 200) {
        // Assuming response.data is a Blob or an ArrayBuffer representing the Excel file
        const url = ROOT_PATH + "ExportedExcel/AttendanceData/" + response.data;

        // Create an anchor element to trigger the download
        const alink = document.createElement('a');
        alink.href = url;
        alink.download = 'attendance_data.xlsx'; // Ensure the correct file name and extension

        // Trigger the download
        alink.click();

        // Clean up the object URL to avoid memory leaks
        window.URL.revokeObjectURL(url);
      }

    } catch (error) {
      _notification.showMessage('error', 'Unable to export attendance data. Please try again.');
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { centerList, Data, loading } = this.state;

    const TableColumns = [
      // {
      //   title: 'ID',
      //   dataIndex: 'Id',
      //   key: 'Id',
      //   width: '4%',
      //   sorter: (a, b) => a.Id - b.Id,
      // },
      {
        title: 'Center',
        dataIndex: 'Center',
        key: 'Center',
        width: '5%',
        filterSearch: true,
        sorter: (a, b) => a.Center.localeCompare(b.Center),
      },
      {
        title: 'Batch',
        dataIndex: 'Batch',
        key: 'Batch',
        width: '5%',
        filterSearch: true,
        sorter: (a, b) => a.Batch.localeCompare(b.Batch),
      },
      {
        title: 'Batch Name',
        dataIndex: 'BatchName',
        key: 'BatchName',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.BatchName.localeCompare(b.BatchName),
      },
      {
        title: 'Batch Time',
        dataIndex: 'BatchTime',
        key: 'BatchTime',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.BatchTime.localeCompare(b.BatchTime),
      },
      {
        title: 'Start Roll Number',
        dataIndex: 'StartRoleNumber',
        key: 'StartRoleNumber',
        width: '8%',
        sorter: (a, b) => a.StartRoleNumber - b.StartRoleNumber,
      },
      {
        title: 'End Roll Number',
        dataIndex: 'EndRoleNumber',
        key: 'EndRoleNumber',
        width: '8%',
        sorter: (a, b) => a.EndRoleNumber - b.EndRoleNumber,
      },
      {
        title: 'Count',
        dataIndex: 'Count',
        key: 'Count',
        width: '5%',
        render: (text, record) =>
          record.EndRoleNumber && record.StartRoleNumber
            ? record.EndRoleNumber - record.StartRoleNumber + 1
            : 0,
      },
      {
        title: 'Exam Date',
        dataIndex: 'ExamDate',
        key: 'ExamDate',
        width: '6%',
        render: (text, record) =>
          moment(record.ExamDate).isValid()
            ? moment(record.ExamDate).format('DD-MMM-YYYY')
            : '',
        sorter: (a, b) => moment(a.ExamDate).unix() - moment(b.ExamDate).unix(),
      },
      {
        title: 'Post',
        dataIndex: 'Post',
        key: 'Post',
        width: '5%',
        filterSearch: true,
        sorter: (a, b) => a.Post.localeCompare(b.Post),
      },
      {
        title: 'Center Name',
        dataIndex: 'CenterName',
        key: 'CenterName',
        width: '5%',
        filterSearch: true,
        sorter: (a, b) => a.CenterName.localeCompare(b.CenterName),
      },
    ];

    return (
      <Spin spinning={loading}>

        <div className="container-fluid p-3">
          <PageHeader
            title="Export Center Wise Attendance Data"
            breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Reports' }, { label: 'Export Center Wise Attendance Data' }]}
          />
          <div className="ent-panel mb-3">
            <Row gutter={16} className="m-0 d-flex align-items-center">
              <Col span={4} className="d-flex align-items-center">
                <label htmlFor="center" className="mb-0 mr-2">Center:</label>

                <DropdownList
                  className="dropdown"
                  id="center" // Ensures the ID is associated with the label
                  placeholder="Select Center"
                  wrapClass="w-100 mb-0"
                  options={centerList}
                  onChange={this.handleCenterChange}
                  value={this.state.selectedCenter}
                  name="Center"
                />
              </Col>
              <Col span={2} style={{fontWeight: "bold", marginLeft:"15px"}}>
                Total Records : {this.state.totalCount}
              </Col>
              <Col span={5}>
                <Button onClick={this.handleDownload}
                  className="button-global button-primary autoWidth autoHeight"
                >Export Attendance Data</Button>
              </Col>

              <Col span={12} className="d-flex align-items-center justify-content-end pr-0">
                <a
                  type="primary"
                  danger
                  className="button-global button-border removebutton addbutton autoWidth d-inline-block text-center autoHeight"
                  onClick={this.handleDeleteConfirmation}
                >   <Icon type="delete" className="mr-2 align-middle mb-1" />
                  Delete Center Attendance Data
                </a>
              </Col>
            </Row>
          </div>
          <div className="mt-3">
            {Data.length === 0 && !loading ? (
              <EmptyState
                title="No Attendance Data Found"
                description="Select a center to view its batch-wise attendance data."
              />
            ) : (
              <Table
                size="small"
                columns={TableColumns}
                dataSource={this.state.Data}  // Ensure the data is passed as the correct format
                rowKey="Id"
                pagination={false}
                className="table-striped-rows admin-table"
              />
            )}
          </div>
        </div>
        <Modal
          footer={false}
          onCancel={() => this.setState({ showDeleteConfirm: false })}
          visible={this.state.showDeleteConfirm}
          className="modelPopAnt admin-home"
        >
          <ConfirmPopup
            message="Are you sure? Do you want to delete the Center wise attendance data?"
            onCancel={() => {
              console.log("Operation canceled.");
              this.setState({ showDeleteConfirm: false });
            }}
            onOk={() => {
              this.setState({ showDeleteConfirm: false });
              return new Promise((resolve, reject) => {
                this.deleteCenterBatchData()
                  .then(() => {
                    message.success("Center wise attendance data deleted successfully!");
                    resolve();
                  })
                  .catch((error) => {
                    message.error("Failed to delete Center wise attendance data.");
                    console.error("Failed to delete Center wise attendance data:", error);
                    reject();
                  });
              });
            }}
          />
        </Modal>
      </Spin>
    );
  }
}

export default ExportCenterWiseAttendanceData;



